import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// views

import Login from "views/auth/Login.js";
import Navbar from "components/Navbars/AuthNavbar";
import FooterSmall from "components/Footers/FooterSmall";
import Dashboard from "views/admin/Dashboard";
import Companies from "views/admin/Companies";
import CreateCompanyPage from "views/admin/CreateCompanyPage";
import Products from "views/admin/Products";
import CreateProductPage from "views/admin/CreateProductPage";

export default function Auth() {
  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-full min-h-screen flex">
          <div
            className="absolute top-0 w-full h-full bg-no-repeat bg-full"
            style={{
              backgroundImage: "url(" + require("assets/img/authbg.jpg").default + ")",
            }}
          ></div>
          <Switch>
            <Route path="/auth/login" exact component={Login} />
            <Route path="/admin/dashboard" exact component={Dashboard} />
            <Route path="/admin/companies" exact component={Companies} />
            <Route path="/admin/company" exact component={CreateCompanyPage} />
            <Route path="/admin/company/:id" exact component={CreateCompanyPage} />"
            <Route path="/admin/products" exact component={Products} />
            <Route path="/admin/product" exact component={CreateProductPage} />
            <Route path="/admin/product/:id" exact component={CreateProductPage} />
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
          <FooterSmall absolute />
        </section>
      </main>
    </>
  );
}
